import { inject, Injectable, signal } from "@angular/core";
import { Note, NoteUpsertValues } from "@interfaces";
import { FuncService } from "../../../../services";

@Injectable({ providedIn: 'root' })
export class NotesEditorService {

	public notesData = signal<Note[]>([]);
	private personId?: number;
	private accVentureId?: number;
	private func = inject(FuncService);

	public async getNotesData(personId?: number, accVentureId?: number) {
		this.notesData.set(await this.func.note.getNotes({ personId, accVentureId }));
		this.personId = personId;
		this.accVentureId = accVentureId;
	}

	// This is used to refresh the notes data after add/edit/delete
	public async reloadNotesData() {
		this.notesData.set(await this.func.note.getNotes({ personId: this.personId, accVentureId: this.accVentureId }));
	}

	public async addNote(note: NoteUpsertValues) {

		await this.func.note.addNote({ note, personId: this.personId, accVentureId: this.accVentureId });
		await this.reloadNotesData();
	}

	public async updateNote(noteId: number, note: NoteUpsertValues) {
		const notes = await this.func.note.updateNote({ noteId, note });
		await this.reloadNotesData();
	}

	public async deleteNote(noteId: number) {
		await this.func.note.deleteNote({ noteId });
		await this.reloadNotesData();
	}
}